import { NgModule } from '@angular/core';
import { AproposComponent } from './apropos.component'
import { AproposService } from './apropos.service'
import { aproposRouting } from './apropos.routes'

@NgModule({
  imports: [
   aproposRouting
  ],
  declarations: [
    AproposComponent
  ],
  providers: [
    AproposService
  ],
  exports: [
    AproposComponent
  ]
})
export class AproposModule { }



// WEBPACK FOOTER //
// C:/Users/Yassine/Desktop/gestion-stagiaires/src/app/apropos/apropos.module.ts